<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2025_3580)">
      <path
        d="M12.5 3.125C13.5512 3.40181 14.5101 3.95267 15.2787 4.72131C16.0473 5.48994 16.5982 6.44882 16.875 7.5"
        class="stroke-primary"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.875 5.625C13.1656 5.97031 14.0297 6.83437 14.375 8.125"
        class="stroke-primary"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.843 11.3547C12.9295 11.2971 13.0291 11.262 13.1326 11.2526C13.2362 11.2432 13.3404 11.2597 13.4359 11.3008L17.1203 12.9515C17.2445 13.0046 17.3481 13.0965 17.4157 13.2134C17.4833 13.3303 17.5112 13.4659 17.4953 13.6C17.3739 14.5071 16.9273 15.3392 16.2383 15.9416C15.5494 16.544 14.6652 16.8757 13.75 16.875C10.9321 16.875 8.22957 15.7556 6.23699 13.763C4.24442 11.7704 3.125 9.06791 3.125 6.24998C3.1243 5.33483 3.456 4.45057 4.05841 3.76165C4.66082 3.07273 5.49293 2.62605 6.4 2.50467C6.53409 2.48874 6.66973 2.51667 6.78662 2.58427C6.90351 2.65187 6.99537 2.7555 7.04844 2.87967L8.69922 6.56717C8.73978 6.66188 8.7563 6.76515 8.7473 6.86778C8.7383 6.97042 8.70407 7.06924 8.64766 7.15545L6.97813 9.14061C6.9189 9.22997 6.88388 9.33317 6.87649 9.44012C6.86909 9.54707 6.88958 9.6541 6.93594 9.75076C7.58203 11.0734 8.94922 12.4242 10.2758 13.064C10.373 13.1102 10.4805 13.1302 10.5878 13.1221C10.695 13.1141 10.7983 13.0781 10.8875 13.018L12.843 11.3547Z"
        class="stroke-primary"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2025_3580">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
